export function tokenToCents(raw: bigint, decimals: number): number {
  // Normalize decimals (defensive: ensure finite, non-negative integer)
  const d = Number.isFinite(decimals) ? Math.max(0, Math.trunc(decimals)) : 0;

  // Convert token units → integer cents by truncation.
  // If token has >=2 decimals, divide by 10^(decimals-2).
  // If token has <2 decimals, multiply by 10^(2-decimals).
  let centsBig: bigint;
  if (d >= 2) {
    const divScale = 10n ** BigInt(d - 2);
    centsBig = raw / divScale;
  } else {
    const mulScale = 10n ** BigInt(2 - d);
    centsBig = raw * mulScale;
  }

  // Clamp to safe JS number range
  const MAX = BigInt(Number.MAX_SAFE_INTEGER);
  if (centsBig > MAX) return Number.MAX_SAFE_INTEGER;
  if (centsBig < -MAX) return -Number.MAX_SAFE_INTEGER;

  return Number(centsBig);
}

export const formatUsd = (cents: number, digits: number = 2) => (cents / 100).toFixed(digits);

export const toBigIntOr = (value: unknown, fallback: bigint = 0n): bigint => {
  try {
    if (typeof value === 'bigint') return value;
    if (typeof value === 'number') return BigInt(value);
    if (typeof value === 'string' && value) return BigInt(value);
    return fallback;
  } catch {
    return fallback;
  }
};

export const toNumberOr = (value: unknown, fallback = 0): number => {
  const n = typeof value === 'number' ? value : value != null ? Number(value) : fallback;
  return Number.isNaN(n) ? fallback : n;
};
